import { MakeCall } from './createMakeCall';

import { KycInfo } from './types/Kyc';

const getKycInfo =
  (makeCall: MakeCall) =>
  (userId: 'me' | number = 'me') =>
    makeCall<KycInfo>('GET', `/api/v2/user/${userId}/kyc-info`);
export { getKycInfo };
